import { Avatar, AvatarFallback, AvatarImage } from "ui";
import { getColorFromInitials, getContrastTextColor, getInitials } from "utils";

interface OrganizationAvatarProps {
  name: string;
  src?: string;
}

export function OrganizationAvatar(props: OrganizationAvatarProps) {
  const initials = getInitials(props.name);
  const backgroundColor = getColorFromInitials(initials);
  const color = getContrastTextColor(backgroundColor);

  return (
    <Avatar className="rounded-[8px] after:rounded-[8px]">
      <AvatarImage className="rounded-[8px]" src={props.src} />
      <AvatarFallback
        className="rounded-[8px] uppercase"
        style={{ backgroundColor, color }}
        delayMs={props.src ? 300 : undefined}
      >
        {initials}
      </AvatarFallback>
    </Avatar>
  );
}
